import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Text, useGlobalization } from '@innovyze/stylovyze';

const CostTableInfoBanner = () => {
  const { t } = useGlobalization();

  return (
    <Stack spacing={1}>
      <Text variant="heading-medium-strong">{t('Cost Table')}</Text>
      <Typography variant="body2" color="text.secondary">
        {t(
          'Click on any Unit Cost cell to edit it. You can also export this table as CSV, fill in the costs in a spreadsheet, and upload it back using the Upload Costs button.'
        )}
      </Typography>
    </Stack>
  );
};

export default CostTableInfoBanner;
